module.exports = __webpack_public_path__ + "static/media/docappt.fa7f57f7.png";